import { c as _c } from "react/compiler-runtime";
import { InfoBar } from "@components/common/info-bar/info-bar";
import { WorkspaceRoleDropdown } from "@components/role/workspace-role-dropdown";
/**
 * Component that shows the info bar of a single member.
 * Shows the workspace role as an editable dropdown (if the user has permission).
 */
export function MemberProfileInfoBar(t0) {
  const $ = _c(2);
  const {
    member
  } = t0;
  let t1;
  if ($[0] !== member) {
    t1 = <InfoBar items={[{
      content: <WorkspaceRoleDropdown member={member} />
    }]} />;
    $[0] = member;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}